import logoImage from "../../images/newHome/logo.86f94e73122a4384fda9.png"
import fbIconImage from "../../images/newHome/fb.svg"
import instaIconImage from "../../images/newHome/insta.svg"
import linkedInIconImage from "../../images/newHome/in.svg"
import ThemeButton from "components/NewHome/ThemeButton";

function NewHomeFooter() {
    return (
        <>
            <footer className="bg-[#F3F3F3] lg:py-[50px] pt-[50px] pb-[26px]">
                <div className="container px-[19px]">
                    <div className="flex flex-col lg:flex-row gap-[40px] lg:gap-[78px]">
                        {/* Logo & Subscription */}
                        <div className="lg:w-1/3 mb-10 lg:mb-0">
                            <img src={logoImage} className="max-w-[224px]" alt="Telcron Logo" />
                            <p className="text-sm text-textColor text-muted my-10 font-poppins">
                                There's a 50% chance that products fail electromagnetic compatibility (EMC) tests the first time, according to at least one leading industry expert.
                            </p>
                            <form className="flex gap-4 lg:pb-4" role="subscribe">
                                <input
                                    type="email"
                                    className="h-11 flex-1 px-3 py-3 border border-[#C6C8D0] rounded-none bg-transparent focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                                    placeholder="Enter your email"
                                />
                                <ThemeButton
                                    type="submit"
                                    bgColor="bg-primaryColor"
                                    textColor="text-white"
                                    padding="h-11 px-3 py-[10px]"
                                    size="font-semibold "
                                    rounded="rounded-none"
                                >
                                    Subscribe
                                </ThemeButton>
                            </form>
                        </div>

                        {/* Footer Links */}
                        <div className="lg:w-2/3">
                            <div className="grid grid-cols-4 gap-2 lg:gap-6">
                                {/* Lab Reservation */}
                                <div>
                                    <h6 className="font-semibold lg:font-bold mb-4 text-xs lg:text-base">Lab Reservation</h6>
                                    <ul className="space-y-2 xl:space-y-4 text-muted font-poppins">
                                        <li><a className="text-xs text-textColor lg:lg:text-base px-0" href="/lab-reservation/schedule-testing">Schedule Testing</a></li>
                                        <li><a className="text-xs text-textColor lg:lg:text-base px-0" href="/lab-reservation/faqs">FAQ</a></li>
                                        <li><a className="text-xs text-textColor lg:lg:text-base px-0" href="/lab-reservation/submit-lab-review">Submit Lab Review</a></li>
                                    </ul>
                                </div>

                                {/* Services */}
                                <div>
                                    <h6 className="font-semibold lg:font-bold mb-4 text-xs lg:text-base">Services</h6>
                                    <ul className="space-y-2 xl:space-y-4 text-muted font-poppins">
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/store">Store</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/services/compliance-management">Compliance Management</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/services/consulting">Consulting</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/services/eSource">Esource</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/services/resources/emc">Resource</a></li>
                                    </ul>
                                </div>

                                {/* About */}
                                <div>
                                    <h6 className="font-semibold lg:font-bold mb-4 text-xs lg:text-base">About</h6>
                                    <ul className="space-y-2 xl:space-y-4 text-muted font-poppins">
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/about/our-capabilities">Capabilities</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/about/our-team">Our Team</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/about/our-partners">Our Partners</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/about/blog">Blog</a></li>
                                    </ul>
                                </div>

                                {/* Schedule Now */}
                                <div>
                                    <h6 className="font-semibold lg:font-bold mb-4 text-xs lg:text-base">Schedule Now</h6>
                                    <ul className="space-y-2 xl:space-y-4 text-muted font-poppins">
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/submit-rfq/get-certified">Submit RFQ for certification</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/lab-reservation/schedule-testing">Test</a></li>
                                        <li><a className="text-xs text-textColor lg:text-base px-0" href="/lab-reservation/schedule-testing">Reserve lab for precertification Testing</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <section className="bg-deepRedStart text-[#EDEDED] py-6 font-lato text-xs lg:text-base leading-[26px]">
                <div className="container">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <div className="order-2 md:order-1">
                            <p className="mb-0 text-center md:text-left font-lato">Privacy Policy | Terms & Conditions</p>
                        </div>
                        <div className="order-3 md:order-2">
                            <p className="mb-0 text-center font-lato">© Copyright Telcron | All Rights Reserved</p>
                        </div>
                        <div className="flex gap-3 order-1 md:order-3">
                            {[fbIconImage, instaIconImage, linkedInIconImage].map((icon, index) => (
                                <div
                                    key={index}
                                    className="w-11 h-11 rounded-full bg-primaryColor flex items-center justify-center"
                                >
                                    <img src={icon} alt={`icon-${index}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default NewHomeFooter;